export default __webpack_public_path__ + "static/media/touch1.d794d2ad.png";